import { render, staticRenderFns } from "./FaqConversationalData.vue?vue&type=template&id=5c0f5972&scoped=true&"
import script from "./FaqConversationalData.vue?vue&type=script&lang=js&"
export * from "./FaqConversationalData.vue?vue&type=script&lang=js&"
import style0 from "./FaqConversationalData.vue?vue&type=style&index=0&id=5c0f5972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f5972",
  null
  
)

export default component.exports